module.exports = __webpack_public_path__ + "img/Adv_perc_numbers.472b00ec.png";